<template>
    <div class="maincontainer">
        <div class="maincolumn">
            500
        </div>
    </div>
</template>

<script>
import { defineComponent } from "vue";

export default defineComponent({
  name: "error-500",
  components: {},
  setup() {

  },
});
</script>
